module.exports = __webpack_public_path__ + "static/img/list.4bf46fb4.svg";